import Swiper from 'swiper/bundle';

import isMobile from './helpers/mobile'


const build = () => {

    if (isMobile()) {
        setSwiper();
    }

}



const setSwiper = e => {
    let swiper = new Swiper('.not-ok .swiper', {
        slidesPerView: 'auto',
        spaceBetween: 30,
        loop: true,
        speed: 600,
        slidesOffsetBefore: 100,
        // autoplay: {
        //     delay: 1000,
        //     disableOnInteraction: false
        // },

        // scrollbar: {
        //     el: '.swiper-scrollbar',
        //     dragSize: 30,

        // },

    });
}


export default () => {
    build()
}